import { theme } from '../../styles/theme';
export const consentBoxItem = {
    border: `1px solid ${theme.palette.common.darkGrey0}`,
    backgroundColor: theme.palette.common.lightGrey4,
    borderRadius: '8px',
    padding: '16px',
    '&:not(:first-of-type)': {
        marginTop: '8px'
    }
};
export const consentBoxLink = {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.palette.common.darkGrey2,
    pointerEvents: 'auto'
};
export const consentBoxCheckbox = {
    padding: '2px',
    margin: '0 7px 0 7px',
    '&.Mui-checked > svg': {
        fill: `${theme.palette.common.violet} !important`
    },
    '&.MuiCheckbox-colorError > svg': {
        fill: `${theme.palette.common.lightRed2} !important`
    }
};
export const consentBoxMandatoryLabel = {
    fontWeight: 600,
    marginTop: '15px',
    fontSize: '14px',
    color: theme.palette.common.violet
};
export const consentBoxError = {
    fontSize: '14px',
    color: theme.palette.common.lightRed2,
    marginTop: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
};
//# sourceMappingURL=ConsentsBox.styles.js.map